import { ReactNode } from 'react';

export type ScheduleInterval = {
  label: string;
  value: string;
  durationMs: number;
};

export type ScheduleConfig = {
  enabled: boolean;
  endTime: string | undefined;
  selectedInterval: string | undefined;
};

export type ScheduleContextValue = {
  config: ScheduleConfig;
  onConfigChange: (config: ScheduleConfig) => void;
  intervals: ScheduleInterval[];
  isDisabled: boolean;
};

export type ScheduleRootProps = {
  config: ScheduleConfig;
  onConfigChange: (config: ScheduleConfig) => void;
  intervals?: ScheduleInterval[];
  isDisabled?: boolean;
  children: ReactNode;
};

export type ScheduleToggleProps = {
  label?: string;
  description?: string;
  'aria-label'?: string;
};

export type ScheduleIntervalSelectProps = {
  label?: string;
  placeholder?: string;
  'aria-label'?: string;
};

export type ScheduleEndTimeFieldProps = {
  label?: string;
  'aria-label'?: string;
};

export type ScheduleInfoListProps = {
  items: string[];
};

const HOUR_MS = 3_600_000;

export const DEFAULT_SCHEDULE_INTERVALS: ScheduleInterval[] = [
  { label: 'Every hour', value: 'PT1H', durationMs: HOUR_MS },
  { label: 'Every 6 hours', value: 'PT6H', durationMs: 6 * HOUR_MS },
  { label: 'Every 12 hours', value: 'PT12H', durationMs: 12 * HOUR_MS },
  { label: 'Daily', value: 'PT24H', durationMs: 24 * HOUR_MS },
];
